import addresses from './addresses';
import attachments from './attachments';
import boardings from './boardings';
import bvs from './bvs';
import campaigns from './campaigns';
import consortiums from './consortiums';
import containers from './containers';
import cooperatives from './cooperatives';
import counterparties from './counterparties';
import counterpartyContracts from './counterparty-contracts';
import contractLineItems from './contract-line-items';
import currencies from './currencies';
import cvExecutions from './cv-executions';
import cvs from './cvs';
import dashboardGlobal from './dashboard-global';
import documentImports from './document-imports';
import dump from './dump';
import farms from './farms';
import farmers from './farmers';
import inboundEmails from './inbound-emails';
import lots from './lots';
import notes from './notes';
import products from './products';
import roles from './roles';
import search from './search';
import settings from './settings';
import transfers from './transfers';
import transitOrders from './transit-orders';
import formulas from './formulas';
import waybills from './waybills';
import waybillsWeighingAnalyses from './waybillsWeighingAnalyses';

export const api: { [key: string]: any } = {
  lots,
  waybills,
  waybillsWeighingAnalyses,
  bvs,
  cvExecutions,
  cvs,
  campaigns,
  consortiums,
  cooperatives,
  counterparties,
  currencies,
  dashboardGlobal,
  documentImports,
  dump,
  farms,
  products,
  addresses,
  attachments,
  counterpartyContracts,
  contractLineItems,
  boardings,
  transitOrders,
  roles,
  search,
  settings,
  containers,
  transfers,
  notes,
  formulas,
  farmers,
  inboundEmails,
};
